import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { setBulkUpdateValue } from 'store/Contextualization/AssetDetail/actions';
import { MODAL_MANAGE_BULK_UPDATE, MODAL_MANAGE_BULK_UPDATE_CONFIRMATION } from 'store/modals/modals';
import { closeModal, openModal } from 'store/modals/actions';
import CommentTextArea from 'Common/Components/CommentTextArea';
import { CommentTextAreaWrapper, Title, Subtitle } from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateModal/components/BulkComment/styled';

const BulkComment = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const subtitle = intl.formatMessage({ id: 'vulns.edit.bulk.comment.subtitle' });
  const title = intl.formatMessage({ id: 'vulns.edit.bulk.comment.title' });
  const placeholder = intl.formatMessage({ id: 'manage.detail.tab.comment.placeholder' });
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const isBulk = vulnsSelected.length > 1;
  const handleClose = () => dispatch(closeModal(MODAL_MANAGE_BULK_UPDATE));

  const onAddComment = (text) => {
    dispatch(setBulkUpdateValue(text));
    dispatch(openModal(MODAL_MANAGE_BULK_UPDATE_CONFIRMATION));
  };

  return (
    <>
      <Subtitle>{ subtitle }</Subtitle>
      <CommentTextAreaWrapper>
        <Title children={ title } />
        <CommentTextArea
          addComment={ (text) => onAddComment(text) }
          entity="vulnerability"
          placeholder={ placeholder }
          isBulk={ isBulk }
          handleClose={ handleClose }
        />
      </CommentTextAreaWrapper>
    </>
  );
};

export default BulkComment;
